'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

type Tab = 'login' | 'signup';

export default function AuthPanel() {
  const [activeTab, setActiveTab] = useState<Tab>('login');

  return (
    <div>
      {/* Mobile logo */}
      <div className="flex items-center gap-2 mb-8 lg:hidden">
        <AppLogo size={28} />
        <span className="font-semibold text-foreground">GlobalAtlas</span>
      </div>

      {/* Tab switcher */}
      <div className="flex bg-muted rounded-lg p-1 mb-8">
        {(['login', 'signup'] as Tab[]).map((tab) => (
          <button
            key={`tab-${tab}`}
            onClick={() => setActiveTab(tab)}
            className={`flex-1 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
              activeTab === tab
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab === 'login' ? 'Sign In' : 'Create Account'}
          </button>
        ))}
      </div>

      {/* Form */}
      <div className="animate-fade-in">
        {activeTab === 'login' ? (
          <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
        ) : (
          <SignupForm onSwitchToLogin={() => setActiveTab('login')} />
        )}
      </div>

      {/* Footer */}
      <p className="text-center text-xs text-muted-foreground mt-6">
        <Link href="/" className="hover:text-foreground transition-colors">← Back to GlobalAtlas.io</Link>
      </p>
    </div>
  );
}